export default (text: string) =>
    text
        .normalize('NFKD')
        .toLowerCase()
        .replace(/\p{Diacritic}/gu, '');
